import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { IntroDialog } from '../intro';
import { ManagerSetupAlert } from './ManagerSetupAlert';
export const ManagerSetup = ({ showAddManagerDetails, }) => {
    const [openModal, setOpenModal] = useState(false);
    const openManagerSettings = useCallback(() => {
        setOpenModal(showAddManagerDetails);
    }, [showAddManagerDetails]);
    const closeManagerSetup = useCallback(() => {
        setOpenModal(false);
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(ManagerSetupAlert, { onOpenManagerSettingsModal: openManagerSettings }), _jsx(IntroDialog, { type: "manager", finish: closeManagerSetup, open: openModal })] }));
};
